import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { TextareaStyle } from './TextareaStyle';

const Textarea = ({
  theme,
  value,
  rows,
  placeholder,
  disabled,
  handleChange,
}) => {
  const [className, setClassName] = useState('textarea-element');

  useEffect(() => {
    const currentClassName = ['textarea-element'];

    if (theme && theme.length) {
      currentClassName.push(`${theme}-theme`);
    }

    setClassName(currentClassName.join(' '));
  }, [theme]);

  return (
    <TextareaStyle>
      <textarea
        className={className}
        value={value}
        rows={rows}
        placeholder={placeholder}
        disabled={disabled}
        onChange={handleChange}
      />
    </TextareaStyle>
  );
};

Textarea.propTypes = {
  theme: PropTypes.string,
  value: PropTypes.string.isRequired,
  rows: PropTypes.number,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
};

Textarea.defaultProps = {
  theme: 'default',
  rows: 4,
  placeholder: '',
  disabled: false,
};

export default Textarea;
